import * as React from "react";

import { Button, DesignToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { ITicket, TicketSilo } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  ticket: ITicket;
  disabled: boolean;
  handleSiloChange: (silo: TicketSilo) => void;
}

const TicketBottomSiloLabel: React.FC<IProps> = ({ ticket, handleSiloChange, disabled }) => {
  const { silo } = ticket;

  const moveTicketToRecent = (): void => {
    handleSiloChange(TicketSilo.Tickets);
    trackEngagement("Tickets: Change silo actions", EventPlace.TicketBottomButton, {
      from: silo,
      to: TicketSilo.Tickets,
      place: EventPlace.TicketBottomButton,
    });
  };

  if (silo === TicketSilo.Tickets) {
    return null;
  }

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      margin="0 60px"
      padding="20px 0"
      css={{ borderTop: `1px solid ${withVar(DesignToken.SurfaceSecondaryDefault)}` }}
    >
      <Button disabled={disabled} onClick={moveTicketToRecent}>
        {silo === TicketSilo.Archive && "Unarchive"}
        {silo === TicketSilo.Spam && "Not spam"}
        {silo === TicketSilo.Trash && "Restore"}
      </Button>
    </Flex>
  );
};

export default TicketBottomSiloLabel;
